import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  InputAdornment,
  IconButton,
  Paper,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { authLoginAsync } from "../data/redux/features/auth/authSlice";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const action = await dispatch(
        authLoginAsync({ email, password })
      ).unwrap();
      localStorage.setItem("token", action.data.token);
      localStorage.setItem("refresh_token", action.data.refresh_token);
      localStorage.setItem("user", JSON.stringify(action.data.user));
      navigate("/");
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Box
      sx={{
        height: "100vh",
        width: "100%",
        backgroundImage:
          "url('https://images.pexels.com/photos/635279/pexels-photo-635279.jpeg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backdropFilter: "blur(8px)",
        position: "relative",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "rgba(0,0,0,0.45)",
        },
      }}
    >
      <Paper
        elevation={6}
        component="form"
        onSubmit={handleSubmit}
        sx={{
          position: "relative",
          zIndex: 2,
          width: "95%",
          maxWidth: "420px",
          padding: "2.5rem",
          borderRadius: "18px",
          textAlign: "center",
          backdropFilter: "blur(10px)",
        }}
      >
        {/* Logo */}
        <img
          src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
          alt="logo"
          width={70}
          style={{ marginBottom: "10px" }}
        />

        {/* Title */}
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", marginBottom: "4px" }}
        >
          🔱 Sanatan Platform Admin
        </Typography>

        <Typography
          variant="h5"
          sx={{ fontWeight: "bold", marginBottom: "10px", color: "#3f51b5" }}
        >
          Welcome
        </Typography>

        <Typography
          variant="body2"
          sx={{ color: "#777", marginBottom: "18px" }}
        >
          Please enter your details to sign in
        </Typography>

        {/* Email */}
        <TextField
          label="Enter your unique ID"
          fullWidth
          margin="normal"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <EmailIcon sx={{ color: "#555" }} />
              </InputAdornment>
            ),
          }}
        />

        {/* Password */}
        <TextField
          label="Enter your password"
          type={showPassword ? "text" : "password"}
          fullWidth
          margin="normal"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <LockIcon sx={{ color: "#555" }} />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)}>
                  {!showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <Typography
          sx={{
            textAlign: "right",
            mt: 1,
            mb: 2,
            fontSize: "14px",
            color: "#3f51b5",
            cursor: "pointer",
          }}
        >
          Forgot Password?
        </Typography>

        {/* Button */}
        <Button
          type="submit"
          variant="contained"
          disabled={!email || !password}
          fullWidth
          sx={{
            py: 1.3,
            borderRadius: "8px",
            background: "#3f51b5",
            "&:hover": { background: "#303f9f" },
          }}
        >
          Sign In
        </Button>

        {/* Phone */}
        <Typography sx={{ fontSize: "14px", mt: 3 }}>
          📞 +91 7023781208
        </Typography>

        {/* Social icons */}
        <Box sx={{ mt: 2, display: "flex", justifyContent: "center", gap: 2 }}>
          <i className="fa-brands fa-instagram"></i>
          <i className="fa-brands fa-facebook"></i>
          <i className="fa-brands fa-youtube"></i>
          <i className="fa-brands fa-linkedin"></i>
        </Box>

        {/* App Store buttons */}
        {/* <Box sx={{ mt: 3, display: "flex", gap: 1, justifyContent: "center" }}>
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
            alt="play"
            height="40"
          />
          <img
            src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
            alt="appstore"
            height="40"
          />
        </Box> */}

        <Typography
          variant="caption"
          display="block"
          sx={{ mt: 2, color: "#888" }}
        >
          © 2025 - Sanatan Platform Admin
        </Typography>
      </Paper>
    </Box>
  );
};

export default Login;
